exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VideoPopup-module__wrapper___1ifon{position:absolute;z-index:5;top:50%;left:50%;transform:translate(-50%,-50%);width:900px;max-width:calc(100dvw - 200px);overflow:auto;background-color:#fff;border-radius:15px;box-shadow:0 0 3px 0 rgba(0,0,0,.1);padding:1em;display:grid;gap:.8rem;position:relative}.VideoPopup-module__wrapper___1ifon .VideoPopup-module__top___3f15F{display:flex;justify-content:space-between;align-items:center;padding-right:.5rem}.VideoPopup-module__wrapper___1ifon .VideoPopup-module__top___3f15F svg{font-size:24px;cursor:pointer}", ""]);

// exports
exports.locals = {
	"wrapper": "VideoPopup-module__wrapper___1ifon",
	"top": "VideoPopup-module__top___3f15F"
};